import {UI} from "../../../../../../../stem-core/src/ui/UIBase";

import {ConfirmationModal} from "../../../../../../ui/ConfirmationModal";
import {Messages} from "../../../../../../Messages";


export class AddressInUseModal extends ConfirmationModal {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            address: null,
            cancelLabel: Messages.close,
            title: Messages.addressInUseTitle,
        };
    }

    getDescription() {
        return [
            Messages.addressInUseDescription,

            "."
        ];
    }
}
